export default __webpack_public_path__ + "static/media/trustWallet.a0ce6f5b.png";